<ion-accordion-group expand="inset">
  <ion-accordion value="accordionAttachment">
    <ion-item slot="header" color="sky">
      <ion-label>
        <i class="fa-solid fa-images"></i> &nbsp; Attach Images
      </ion-label>
    </ion-item>
    <div class="ion-padding" slot="content">
      <ion-grid>
        <div class="row">
          <div class="col text-center">
            <p>
              <i class="fas fa-info-circle"></i>&nbsp;
              <span *ngIf="allowedUploadImage">These images and captions will be used in Report.</span>
              <span *ngIf="!allowedUploadImage">You are not authorised to perform this operation.</span>
            </p>
          </div>
        </div>
        <div class="row" *ngIf="allowedUploadImage && exceedMaxLimit">
          <div class="col text-center">
            <p><i class="fas fa-info-circle"></i>&nbsp;You have reached maximum limit.</p>
          </div>
        </div>
        <ion-row *ngIf="allowedUploadImage && !exceedMaxLimit">
          <ion-col size="12">
            <div class="row align-middle text-center">
              <div class="col align-middle text-center">
                <div
                  *ngIf="files.length == 0"
                  class="custom-dropzone"
                  ngx-dropzone
                  [accept]="'image/*'"
                  (change)="onSelect($event)"
                >
                  <ngx-dropzone-label>
                    <div>
                      <h6>Tap/Drop here to add your Attachment</h6>
                      <h6>(png/jpg) image file formats supported</h6>
                    </div>
                  </ngx-dropzone-label>
                </div>
                <ngx-dropzone-image-preview
                  ngProjectAs="ngx-dropzone-preview"
                  *ngFor="let f of files"
                  [file]="f"
                  [removable]="true"
                  (removed)="onRemove(f)"
                >
                  <ngx-dropzone-label>
                    <button type="button" class="btn btn-outline-info btn-sm btn-block" (click)="onRemove(f)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </ngx-dropzone-label>
                </ngx-dropzone-image-preview>
              </div>
            </div>

            <div class="container my-2">
              <div class="row easie-form" *ngIf="files.length > 0">
                <div class="col-12 mx-auto p-2">
                  <label class="field-label" for="caption">Caption</label>
                  <input type="text" id="caption" class="form-control" [(ngModel)]="caption" />
                </div>
              </div>
            </div>
          </ion-col>
          <ion-col size="12">
            <ion-button *ngIf="files.length > 0" (click)="uploadAttachment()" expand="block" class="text-white">
              <i class="fas fa-cloud-upload-alt"></i> &nbsp; Upload Attachment
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item-sliding *ngFor="let attachment of attachmentsWithName; let i = index">
              <ion-item lines="none" (click)="download(attachment)">
                <ion-thumbnail slot="start">
                  <img src="{{ attachment.url }}" />
                </ion-thumbnail>
                <ion-label>
                  <ion-text color="primary">
                    <h3>&nbsp; {{ attachment.fileName }}</h3>
                  </ion-text>
                  <p>&nbsp; {{ attachment.caption }}</p>
                </ion-label>
                <i class="fas fa-angle-double-left"></i>
              </ion-item>
              <ion-item-options side="end">
                <ion-item-option
                  color="success"
                  (click)="editCaption(attachment.key, attachment.caption, attachment)"
                >
                  <i class="fas fa-edit"></i>
                </ion-item-option>
                <ion-item-option color="danger" (click)="remove(attachment.url)">
                  <i class="fas fa-trash"></i>
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-accordion>
</ion-accordion-group>

<!-- 
<div class="accordion p-2 m-2" id="accordionAttachment">
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button
        class="accordion-button collapsed bg-info-easie-100"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOneAttachment"
        aria-expanded="false"
        aria-controls="collapseOneAttachment"
        [disabled]="!subscriptionStatus"
      >
      <i class="fa-solid fa-images"></i> &nbsp; Attach Images
      </button>
    </h2>
    <div id="collapseOneAttachment" class="accordion-collapse collapse" data-bs-parent="#accordionAttachment">
      <div class="accordion-body">
        <div class="card-body segment-label p-1">
          
        </div>
      </div>
    </div>
  </div>
</div> -->